import { LOAD_TYPE, LOAD_TYPE_SUCCESS } from './constants';

/**
 * Load type
 */
export function loadType(value) {
  return {
    type: LOAD_TYPE,
    value,
  };
}

export function loadTypeSuccess(response) {
  return {
    type: LOAD_TYPE_SUCCESS,
    response,
  };
}
